module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"group":[{"fieldValue":"Corning","totalCount":1},{"fieldValue":"Drs","totalCount":1},{"fieldValue":"New York","totalCount":1},{"fieldValue":"Partner","totalCount":1},{"fieldValue":"SUNY","totalCount":1},{"fieldValue":"test","totalCount":2}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags.json
// module id = 440
// module chunks = 55702396619907